import React from "react";
import dayjs from "dayjs";
import "dayjs/locale/de";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField } from "@mui/material";

const AppDatePicker = ({
  value,
  onChange,
  error,
  helperText,
  slotProps,
  size,
  fullWidth,
  disabled,
  ...props
}) => {
  // value erwartet: "YYYY-MM-DD"
  const dateValue = value ? dayjs(value, "YYYY-MM-DD", true) : null;

  const handleDateChange = (date, context) => {
    if (!onChange) return;
    if (context?.validationError) {
      return;
    }
    if (date && date.isValid && date.isValid()) {
      onChange(date.format("YYYY-MM-DD"));
      return;
    }
    if (date === null) {
      onChange(null);
    }
  };

  const renderTextField = React.useCallback((params) => <TextField {...params} />, []);
  const mergedTextFieldProps = {
    ...slotProps?.textField,
    ...(fullWidth !== undefined ? { fullWidth } : {}),
    ...(size ? { size } : {}),
    ...(disabled !== undefined ? { disabled } : {}),
    ...(error !== undefined ? { error } : {}),
    ...(helperText !== undefined ? { helperText } : {}),
    inputProps: {
      ...slotProps?.textField?.inputProps,
      placeholder: "tt.mm.jjjj",
    },
  };
  const mergedSlotProps = {
    ...slotProps,
    textField: mergedTextFieldProps,
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
      <DatePicker
        value={dateValue}
        onChange={handleDateChange}
        format="DD.MM.YYYY"
        disabled={disabled}
        slots={{
          renderTextField,
        }}
        slotProps={mergedSlotProps}
        {...props}
      />
    </LocalizationProvider>
  );
};

export default AppDatePicker;
